import styled from 'styled-components';

export const FormSection = styled.div`
  padding: 24px;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    border-bottom: none;
  }

  .ant-row,
  .ant-form-item {
    width: 100%;
  }
`;
